/**
 * Created by Ning Jiang on 2/21/2020.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData, ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {DWBackground} from "../../background/DWBackground";
import {DeadwoodSoundConfig} from "../../DeadwoodSoundConfig";
import {DeadwoodParsedGameData} from "../../server/data/DeadwoodParsedGameData";
import {DeadwoodReelSymbol} from "../../symbols/DeadwoodReelSymbol";
import {BonusReelNearWinView} from "./BonusReelNearWinView";

export class BonusReelNearWinController extends ReelStopPresentationController {

    private _view:BonusReelNearWinView;

    private _nearWinData:boolean[];
    private _bonusTriggered:boolean;
    private _freespinTriggered:boolean;
    private _fsSuperModeActive:boolean;
    private _mode:string;
    private _isPlaying:boolean;

    constructor(index:number) {
        super(index, "bonusNearWin");

        this._view = new BonusReelNearWinView();
        this._isPlaying = false;
    }

    protected parseFeatureGameData(data:DeadwoodParsedGameData):void {
        this._nearWinData = data.nearWinReels;
        this._bonusTriggered = data.bonusTriggeredThisSpin;
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._fsSuperModeActive = data.fsSuperModeActive;
        this._mode = data.mode;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinReelEvent.REEL_ON_NEAR_WIN, (event:GameEvent) => this.onReelNearWin(event.params[0]));
    }

    private onReelNearWin(reelId:number):void {
        if(reelId !== 4) {
            return;
        }

        if(!this._nearWinData[reelId]) {
            // exclude big win near win.
            return;
        }

        // For both near win in main game and fs.
        this._isPlaying = true;
        const reel:ReelController = Reels.getReel(reelId)!;
        reel.view.parent.addChild(reel.view);
        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.ANTICIPATION_STAR);
        this._view.playBonusNearWin(reelId);
        // EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.ADD_SLOW_ATTENTION_SPIN_SYMBOL_TO_REEL, {
        //     reelId : 4,
        //     symName : ReelSymbolName.BONUS,
        //     spinSpeed : 0.6,
        //     startPosition : -1,
        //     steps : 4,
        //     symbolState : DeadwoodGameConfig.instance.SYMBOL_STATES.normal
        // }));

        // loop the low symbols.
        for(let i:number = 1; i < 4; i++) {
            for(let j:number = 0; j < 4; j++) {
                const symbol:DeadwoodReelSymbol = <DeadwoodReelSymbol>Reels.getSymbol(i, j);
                if(!symbol) {
                    continue;
                }
                if(symbol.symName.includes("L")) {
                    symbol.burnBonus(true, true);
                }
            }
        }
        EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_BONUS_FRAME, true, true));
        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0.6, 2));
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 4) {
            EventHandler.dispatchEvent(new GameEvent(DWBackground.BURN_BONUS_FRAME, this._fsSuperModeActive, false));

            if(this._isPlaying) {
                SlotGame.sound.stopEffect(DeadwoodSoundConfig.instance.ANTICIPATION_STAR);
                this._isPlaying = false;
                this._view.stopNearWin(data.reelId);

                if(!this._bonusTriggered) {
                    if(!this._freespinTriggered) {
                        SlotGame.sound.playEffect(DeadwoodSoundConfig.instance.ANTICIPATION_STAR_FAIL);
                    }
                    // stop burn low symbols.
                    for(let i:number = 1; i < 4; i++) {
                        for(let j:number = 0; j < 4; j++) {
                            const symbol:DeadwoodReelSymbol = <DeadwoodReelSymbol>Reels.getSymbol(i, j);
                            if(!symbol) {
                                continue;
                            }
                            if(symbol.symName.includes("L")) {
                                symbol.burnBonus(false, false);
                            }
                        }
                    }
                    if(this._mode === GameMode.NORMAL && !this._freespinTriggered) { // do not reset the dim in fs modes.
                        EventHandler.dispatchEvent(new GameEvent(DWBackground.DIM_STAGE, 0, 0.35));
                    }
                }
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }

    protected resetFeature():void {
        this._view.reset();
    }
}